<template>
	<div class="range-inline">
		{{label}} <range-list :items="items" @select="$emit('select', $event)" :view="view" :rangetype="rangetype"/>
	</div>
</template>

<script>
import RangeList from "@/features/filters/range/RangeList.vue";

export default {
	name: "RangeInline",
	components: {RangeList},
	props:{
		items:{
			type:Array
		},
		label:{
			type: String
		},
		view: String,
		rangetype:String
	}
}
</script>

<style lang="scss">
	.range-inline {
		display: flex;
		column-gap: 1em;
		flex-wrap: wrap;
		.range-list{
			display: flex;
			overflow: hidden;
			border-radius: 4px;
			border: 1px solid #aeaeae;
			.list-item {
				border-right: 0px solid #aeaeae;
				&:last-child{
					border-right: none;
				}
			}
		}
	}
</style>
